import { type FC } from 'react';

import { type EocCheckinChatbot } from '@editor2/types/pageElements';
import ChangesDiff from '../common/ChangesDiff';
import { elementHeader } from '../styles';
import { conceptsToString } from './keyConceptsDiffFormat';

interface Props {
	title: string;
	index: number;
	initialIndex: number;
	initialElement: EocCheckinChatbot;
	currentElement: EocCheckinChatbot;
	attributeChanges: any;
	parentName: string;
}

const KeyConceptsDiff: FC<Props> = (props) => {
	const { title, index, initialIndex, initialElement, currentElement, attributeChanges, parentName } =
		props;

	const { key_concepts } = attributeChanges;

	return (
		<ChangesDiff
			title={title}
			index={index}
			initialIndex={initialIndex}
			initial={{
				...initialElement,
				...(initialElement && {
					key_concepts: conceptsToString(initialElement.key_concepts) as any
				})
			}}
			attributeChanges={{
				...attributeChanges,
				...(key_concepts !== undefined && {
					key_concepts: conceptsToString(key_concepts ?? currentElement.key_concepts)
				})
			}}
			parentName={parentName}
			styles={elementHeader}
		/>
	);
};

export default KeyConceptsDiff;
